import { Autocomplete, Checkbox, FormControlLabel, Grid, MenuItem, Paper, TextField } from '@mui/material'
import type { SupplierFilters as SupplierFiltersType } from './SupplierList.types'

export interface SupplierFiltersProps {
  filters: SupplierFiltersType
  onFiltersChange: (filters: SupplierFiltersType) => void
  supplierOptions: string[]
  typeOptions: string[]
  oemOptions: readonly string[]
}

export function SupplierFilters({
  filters,
  onFiltersChange,
  supplierOptions,
  typeOptions,
  oemOptions,
}: SupplierFiltersProps) {
  const updateFilter = (key: keyof SupplierFiltersType, value: string | boolean) => {
    onFiltersChange({ ...filters, [key]: value })
  }

  return (
    <Paper
      elevation={0}
      sx={{
        mx: 2,
        mt: 2,
        mb: 2,
        px: 2,
        py: 2,
        background: '#fff',
        boxShadow: '0 4px 4px 0 rgba(0,0,0,0.25)',
        borderRadius: 1,
      }}
    >
      <form onSubmit={e => e.preventDefault()}>
        <Grid container spacing="24px" alignItems="center">
          <Grid size={3.5}>
            <Autocomplete
              options={supplierOptions}
              value={filters.supplier || null}
              onChange={(_event, newValue) => updateFilter('supplier', newValue ?? '')}
              clearOnEscape
              renderInput={params => <TextField {...params} label="Suppliers" size="small" fullWidth />}
            />
          </Grid>

          <Grid size={3.5}>
            <TextField
              fullWidth
              size="small"
              select
              value={filters.oem}
              onChange={e => updateFilter('oem', e.target.value)}
              label="OEM"
            >
              <MenuItem value="">
                <em>OEM</em>
              </MenuItem>
              {oemOptions.map(o => (
                <MenuItem key={o} value={o}>
                  {o}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid size={3.5}>
            <TextField
              fullWidth
              size="small"
              select
              value={filters.type}
              onChange={e => updateFilter('type', e.target.value)}
              label="Type"
            >
              <MenuItem value="">
                <em>Type</em>
              </MenuItem>
              {typeOptions.map(t => (
                <MenuItem key={t} value={t}>
                  {t}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid size="auto">
            <FormControlLabel
              label="Blanket"
              control={<Checkbox checked={filters.blanket} onChange={e => updateFilter('blanket', e.target.checked)} />}
            />
          </Grid>
        </Grid>
      </form>
    </Paper>
  )
}
